import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-ring"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M17 12C17 9.23858 14.7614 7 12 7V2C17.5228 2 22 6.47715 22 12H17Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M22 12H17C17 13.3754 16.4447 14.621 15.546 15.525L19.0816 19.0605C20.8851 17.2517 22 14.7561 22 12Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 12C17 9.23858 14.7614 7 12 7M17 12H22M17 12C17 13.3754 16.4447 14.621 15.546 15.525M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C13.3861 17 14.6404 16.436 15.546 15.525M12 7V2M22 12C22 6.47715 17.5228 2 12 2M22 12C22 14.7561 20.885 17.2517 19.0816 19.0605M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C14.7668 22 17.2711 20.8764 19.0816 19.0605M15.546 15.525L19.0816 19.0605","strokeWidth":"props.strokeWidth"}}]}]};

const ChartRing = Vue.extend<IconProps>({
  name: 'ChartRingIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chart-ring',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChartRing;
